import React from 'react';

import { User } from 'api/endPoints/getReport';

import { Avatar } from 'components/common/Avatar/Avatar';
import { ForesightLogo } from 'components/common/ForesightLogo/ForesightLogo';

import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/BuiltByBadge/BuiltByBadge.module.scss';

interface Props {
    user: User;
    showFullName?: boolean;
    createdByFSW?: boolean;
}

export const BuiltByBadge = ({ user, createdByFSW, showFullName = true }: Props) => {
    if (!user) return null;

    if (createdByFSW) {
        return <ForesightLogo width={28} withBackground={true} />;
    }
    return (
        <div className={classes.userTitle}>
            <Avatar fullName={`${user.firstName} ${user.lastName}`} isUnassigned={false} className={classes.avatar} />
            {showFullName && <span>{`${user.firstName} ${user.lastName}`}</span>}
        </div>
    );
};
